import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { mainMenuItems, otherMenuItems } from "./Sidebar";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SearchIcon from "@mui/icons-material/Search";

export default function Topbar() {
  const [search, setSearch] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [openUserMenu, setOpenUserMenu] = useState(false);

  const navigate = useNavigate();

  // const flattenMenuItems = (items) => {
  //   return items.flatMap(item => {
  //     if (item.children && item.children.length > 0) {
  //       return item.children;
  //     }
  //     return item;
  //   });
  // };

  const flattenMenuItems = (items) => {
    return items.flatMap((item) => {
      if (item.children && item.children.length > 0) {
        return flattenMenuItems(item.children);
      }

      return item.path ? [item] : [];
    });
  };

  // const handleSearchChange = (e) => {
  //   const value = e.target.value;
  //   setSearch(value);

  //   if (value.trim() === "") {
  //     setFilteredItems([]);
  //     return;
  //   }

  //   const flatMain = flattenMenuItems(mainMenuItems);
  //   const flatOther = flattenMenuItems(otherMenuItems);

  //   const allMenuItems = [...flatMain, ...flatOther];

  //   const filtered = allMenuItems.filter(item =>
  //     item.label.toLowerCase().includes(value.toLowerCase())
  //   );

  //   setFilteredItems(filtered);
  // };

  // Click suggestion
  
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);

    if (value.trim() === "") {
      setFilteredItems([]);
      return;
    }

    const flatMain = flattenMenuItems(mainMenuItems);
    const flatOther = flattenMenuItems(otherMenuItems);

    const allMenuItems = [...flatMain, ...flatOther];

    const filtered = allMenuItems.filter((item) =>
      item.label.toLowerCase().includes(value.trim().toLowerCase())
    );

    setFilteredItems(filtered);
  };

  const handleSelect = (path) => {
    setSearch("");
    setFilteredItems([]);
    navigate(path);
  };

  // Logout
  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    navigate("/login");
  };

  const accountData = JSON.parse(localStorage.getItem("accountData"));

  return (
    <div className="relative flex items-center justify-between pl-20 lg:pl-5 bg-gray-100 shadow p-4">
      {/* Search Bar */}
      <div className="relative w-full max-w-md">
        <div className="flex items-center bg-white rounded-md px-4 py-2 border border-theme-color shadow-sm">
          <SearchIcon className="text-theme-color mr-2" />
          <input
            type="text"
            value={search}
            onChange={handleSearchChange}
            placeholder="Search menu..."
            className="bg-transparent outline-none w-full text-gray-700"
          />
        </div>

        {/* Dropdown Suggestions */}
        {filteredItems.length > 0 && (
          <ul className="absolute z-10 bg-white mt-1 w-full rounded-md shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
            {filteredItems.map((item, idx) => (
              <li
                key={idx}
                onClick={() => handleSelect(item.path)}
                className="flex items-center gap-2 px-4 py-2 hover:bg-theme-color/20 cursor-pointer transition"
              >
                <span className="text-gray-600 text-lg">{item.icon}</span>
                <span className="text-gray-700">{item.label}</span>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* User Icon + Dropdown */}
      <div className="relative">
        <div
          onClick={() => setOpenUserMenu((prev) => !prev)}
          className="flex items-center gap-2 ml-4 cursor-pointer"
        >
          <span className="border-b border-theme-color">{`${accountData?.username ? accountData?.username : ""}`}</span>
          <AccountCircleIcon className="text-theme-color text-3xl" />
        </div>

        {/* User Dropdown Panel */}
        {openUserMenu && (
          <div className="absolute right-0 mt-2 w-40 bg-white shadow-lg rounded-md border border-gray-200 z-20">
            <button
              onClick={handleLogout}
              className="w-full text-left px-4 py-2 hover:bg-red-100 text-red-700"
            >
              Log out
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
